import { useEffect, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { api, imageUrl } from "@/lib/api";
import { Link } from "react-router-dom";
import { MapTrifold } from "@phosphor-icons/react";

const DOMAIN_COLOR = {
  Travel: "#F27A54", Food: "#F97316", Institutions: "#7C3AED", Events: "#EC4899",
  Geographic: "#0EA5E9", Nature: "#16A34A", Objects: "#64748B", People: "#EF4444",
};

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length) {
      const latlngs = points.map((p) => [p.lat, p.lon]);
      try { map.fitBounds(latlngs, { padding: [50, 50], maxZoom: 12 }); } catch (e) { /* */ }
    }
  }, [points, map]);
  return null;
}

export default function MapView() {
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/map").then((r) => setPoints(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-[1400px]">
      <div className="flex items-end justify-between">
        <div>
          <p className="overline text-[#F27A54]">Geographic View</p>
          <h1 className="mt-1 font-display text-3xl font-black tracking-tight">Photo Map</h1>
        </div>
        <span className="text-sm text-muted-foreground">{points.length} geolocated photos</span>
      </div>

      <div className="mt-2 flex flex-wrap gap-3">
        {Object.entries(DOMAIN_COLOR).map(([d, c]) => (
          <span key={d} className="flex items-center gap-1.5 text-xs text-zinc-600">
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: c }} /> {d}
          </span>
        ))}
      </div>

      <div className="relative mt-4 h-[70vh] overflow-hidden rounded-md border border-border">
        {loading ? (
          <div className="grid h-full place-items-center text-muted-foreground">Loading map…</div>
        ) : points.length === 0 ? (
          <div className="grid h-full place-items-center text-center">
            <div>
              <MapTrifold size={44} weight="thin" className="mx-auto text-zinc-300" />
              <p className="mt-3 font-display font-bold">No geolocated photos yet</p>
              <p className="text-sm text-muted-foreground">Upload photos with GPS EXIF data to see them here.</p>
            </div>
          </div>
        ) : (
          <MapContainer center={[20, 0]} zoom={2} scrollWheelZoom className="h-full w-full">
            <TileLayer
              attribution='&copy; OpenStreetMap contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <FitBounds points={points} />
            {points.map((p) => (
              <CircleMarker key={p.id} center={[p.lat, p.lon]} radius={8}
                pathOptions={{ color: "#fff", weight: 2, fillColor: DOMAIN_COLOR[p.domain] || "#F27A54", fillOpacity: 0.9 }}>
                <Popup>
                  <Link to={`/photos/${p.id}`} className="block w-44">
                    <img src={imageUrl(p.id)} alt="" className="mb-1.5 h-24 w-full rounded object-cover" />
                    <p className="text-xs font-semibold">{p.caption || "Photo"}</p>
                    <p className="text-[11px] text-zinc-500">{[p.city, p.country].filter(Boolean).join(", ")}</p>
                  </Link>
                </Popup>
              </CircleMarker>
            ))}
          </MapContainer>
        )}
      </div>
    </div>
  );
}
